var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { BigNumber } from 'ethers';
export function findBestMatch(query, searchResults, returnOne) {
    if (returnOne === void 0) { returnOne = false; }
    var filteredResults = searchResults.filter(function (token) {
        var _a;
        if (BigNumber.from(token.liquidity).lt(BigNumber.from(25))) {
            return false;
        }
        if ((token === null || token === void 0 ? void 0 : token.isScam) || ((_a = token === null || token === void 0 ? void 0 : token.token) === null || _a === void 0 ? void 0 : _a.networkId) === 5) {
            return false;
        }
        return true;
    });
    // split into two groups, one with less than 50 txns in the last 24 hours, and one with more than 50
    var lessThan50 = [];
    var moreThan50 = [];
    // Manually partition the filtered results
    filteredResults.forEach(function (result) {
        if (!result.txnCount24 || BigNumber.from(result.txnCount24).lt(BigNumber.from(50))) {
            lessThan50.push(result);
        }
        else {
            moreThan50.push(result);
        }
    });
    lessThan50.sort(function (a, b) {
        var volumeA = BigInt(a.volume24);
        var volumeB = BigInt(b.volume24);
        // For descending order, compare b to a
        if (volumeA > volumeB) {
            return -1;
        }
        if (volumeA < volumeB) {
            return 1;
        }
        return 0;
    });
    // order the more than 50 txn/day group by volume/unique sellers
    moreThan50.sort(function (a, b) {
        var ratioA = !a.uniqueSells24 || !a.volume24
            ? BigInt(0)
            : BigInt(BigNumber.from(a.volume24).div(BigNumber.from(a.uniqueSells24)).toString());
        var ratioB = !b.uniqueSells24 || !b.volume24
            ? BigInt(0)
            : BigInt(BigNumber.from(b.volume24).div(BigNumber.from(b.uniqueSells24)).toString());
        // For descending order, compare b to a
        if (ratioA > ratioB) {
            return -1;
        }
        if (ratioA < ratioB) {
            return 1;
        }
        return 0;
    });
    var lessThanFiftyOrderedByVolume = lessThan50;
    var fiftyOrMoreOrderedByUniqueSellers = moreThan50;
    // split the more than 50 txn/day group into two groups, one with exact matches and one with inexact matches
    var fiftyOrMoreExactMatches = [];
    var fiftyOrMoreInexactMatches = [];
    fiftyOrMoreOrderedByUniqueSellers.forEach(function (result) {
        var _a, _b, _c, _d, _e, _f;
        var isMatch = (_f = [
            (_a = result.token) === null || _a === void 0 ? void 0 : _a.symbol.toLowerCase(),
            (_c = (_b = result.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase(),
            (_e = (_d = result.token) === null || _d === void 0 ? void 0 : _d.name) === null || _e === void 0 ? void 0 : _e.toLowerCase(),
        ]) === null || _f === void 0 ? void 0 : _f.includes(query.toLowerCase());
        if (isMatch) {
            fiftyOrMoreExactMatches.push(result);
        }
        else {
            fiftyOrMoreInexactMatches.push(result);
        }
    });
    // split the 50 or more unique txn/day exact matches into two groups, one with over 100k volume and one with under 100k volume
    var exactMatchesOver50TxnsAnd100kVol = [];
    var exactMatchesOver50TxnsAndUnder100kVol = [];
    fiftyOrMoreExactMatches.forEach(function (result) {
        if (BigNumber.from(result.volume24).gt(BigNumber.from('100000'))) {
            exactMatchesOver50TxnsAnd100kVol.push(result);
        }
        else {
            exactMatchesOver50TxnsAndUnder100kVol.push(result);
        }
    });
    var twoDaysAgo = Math.floor(new Date().getTime() / 1000) - 60 * 60 * 24 * 2;
    // split the 50 or more unique txn/day exact matches with over 100k vol into two groups, one with older than 2 days and one with newer than 2 days
    var olderFiftyOrMoreAnd100kVolExactMatches = exactMatchesOver50TxnsAnd100kVol.filter(function (result) {
        return result.createdAt < twoDaysAgo;
    });
    var newerFiftyOrMoreAnd100kVolExactMatches = exactMatchesOver50TxnsAnd100kVol.filter(function (result) {
        return result.createdAt >= twoDaysAgo;
    });
    // Prepare the final sorted array
    var sortedResults = [];
    // Add older exact matches with over 50 txns/day and over 100k volume
    sortedResults.push.apply(sortedResults, olderFiftyOrMoreAnd100kVolExactMatches.sort(function (a, b) {
        return Number(BigInt(b.volume24 ? b.volume24 : '0') - BigInt(a.volume24 ? a.volume24 : '0'));
    }));
    // Add newer exact matches with over 50 txns/day and over 100k volume
    sortedResults.push.apply(sortedResults, newerFiftyOrMoreAnd100kVolExactMatches.sort(function (a, b) {
        return Number(BigInt(b.volume24 ? b.volume24 : '0') - BigInt(a.volume24 ? a.volume24 : 0));
    }));
    // Add exact matches with over 50 txns/day and under 100k volume
    sortedResults.push.apply(sortedResults, exactMatchesOver50TxnsAndUnder100kVol.sort(function (a, b) { return a.createdAt - b.createdAt; }));
    // Add exact matches with under 50 txns/day
    var lessThanFiftyExactMatches = lessThanFiftyOrderedByVolume.filter(function (result) {
        var _a, _b, _c, _d, _e, _f, _g;
        return (_g = [
            (_b = (_a = result.token) === null || _a === void 0 ? void 0 : _a.symbol) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
            (_d = (_c = result.token) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.toLowerCase(),
            (_f = (_e = result.token) === null || _e === void 0 ? void 0 : _e.name) === null || _f === void 0 ? void 0 : _f.toLowerCase(),
        ]) === null || _g === void 0 ? void 0 : _g.includes(query.toLowerCase());
    });
    sortedResults.push.apply(sortedResults, lessThanFiftyExactMatches);
    // Add inexact matches
    var inexactMatches = __spreadArray(__spreadArray([], fiftyOrMoreInexactMatches, true), lessThanFiftyOrderedByVolume.filter(function (result) {
        var _a, _b, _c, _d, _e, _f, _g;
        return !((_g = [
            (_b = (_a = result.token) === null || _a === void 0 ? void 0 : _a.symbol) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
            (_d = (_c = result.token) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.toLowerCase(),
            (_f = (_e = result.token) === null || _e === void 0 ? void 0 : _e.name) === null || _f === void 0 ? void 0 : _f.toLowerCase(),
        ]) === null || _g === void 0 ? void 0 : _g.includes(query.toLowerCase()));
    }), true);
    // Sort inexact matches: ETH tokens first, then others
    var ethTokens = inexactMatches.filter(function (result) { var _a; return result.token && ((_a = result === null || result === void 0 ? void 0 : result.token) === null || _a === void 0 ? void 0 : _a.networkId) === 1; });
    var otherTokens = inexactMatches.filter(function (result) { var _a; return !result.token || ((_a = result === null || result === void 0 ? void 0 : result.token) === null || _a === void 0 ? void 0 : _a.networkId) !== 1; });
    sortedResults.push.apply(sortedResults, __spreadArray(__spreadArray([], otherTokens, false), ethTokens, false));
    if (returnOne) {
        return sortedResults[0] ? [sortedResults[0]] : null;
    }
    else {
        if ((sortedResults === null || sortedResults === void 0 ? void 0 : sortedResults.length) == 0)
            return searchResults;
        return sortedResults;
    }
}
